import { NavLink, NavLinkProps } from '@remix-run/react';
import { Icon, iconNameMap } from '../../Icon';
import clsx from 'clsx';
import { Tooltip, TooltipContainer } from '../../Tooltip';

export type SidebarMenuItemProps = {
  iconName: keyof typeof iconNameMap | ((p: { isActive: boolean }) => React.ReactNode);
  className?: string;
  withBadge?: boolean;
  tooltipText?: string;
  navLinkProps: Omit<NavLinkProps, 'className'>;
};

export const SidebarMenuItem = ({
  iconName,
  className,
  navLinkProps,
  tooltipText,
  withBadge,
}: SidebarMenuItemProps): JSX.Element => {
  return (
    <NavLink
      {...navLinkProps}
      className={({ isActive }) =>
        clsx(
          'flex w-16 min-w-16 md:min-w-full md:w-full rounded-[20px] md:rounded-none h-12 md:h-[56px] justify-center items-center md:mb-[8px] cursor-pointer',
          isActive && 'bg-palette-900  md:bg-palette-500/70',
          '[&_.tooltip-reference-element-trigger]:grid [&_.tooltip-reference-element-trigger]:place-content-center [&_.tooltip-reference-element-trigger]:!h-[inherit] [&_.tooltip-reference-element-trigger]:!w-[inherit]',
          className
        )
      }
    >
      {({ isActive }) => (
        <Tooltip
          inPortal={false}
          placement="right"
          offset={[0, -16]}
          floatingElement={<TooltipContainer className="text-white">{tooltipText}</TooltipContainer>}
        >
          <div className="relative">
            {withBadge && (
              <>
                <span className="absolute -top-1 -right-1 bg-darkMode-danger/80 border border-darkMode-danger rounded-full w-3 h-3 animate-ping" />
                <span className="absolute -top-1 -right-1 bg-darkMode-danger/80 border border-darkMode-danger rounded-full w-3 h-3" />
              </>
            )}
            {typeof iconName === 'string' ? (
              <Icon
                className={clsx('md:w-[32px] md:h-[32px] h-6 w-6', isActive ? 'text-palette-100' : 'text-palette-200')}
                icon={iconName as keyof typeof iconNameMap}
              />
            ) : (
              iconName({ isActive })
            )}
          </div>
        </Tooltip>
      )}
    </NavLink>
  );
};
